import { ViewFactory } from 'wdc-cube-react'

import { AnaliseDesempenhoScope, HeaderScope } from '../ad_scopes'
import AnaliseDesempenhoView, { HeaderView } from './ad_view'

export function registerViews(rv = ViewFactory.register) {
    rv(AnaliseDesempenhoScope, AnaliseDesempenhoView)
    rv(HeaderScope, HeaderView)
}
